import React, { useState } from 'react'
import PropTypes from 'prop-types'
// import FlagTeam from '@assets/images/placeholder/flag-placeholder.png'
// import dynamic from 'next/dynamic'
// import { S3_PREFIX } from '@shared/constants'
import { formatScoreData } from '@shared/utils'
import { useSubscription } from '@apollo/client'
import { GET_CUSTOM_SCORE_SUBSCRIPTION } from '@graphql/article/article.subscription'
import { GET_MATCH_HEADER } from '@graphql/match/match.subscription'
// import { Badge } from 'react-bootstrap'
// import Trans from 'next-translate/Trans'
// import styles from './style.module.scss'
// import CustomLink from '@shared/components/customLink'
// import { allRoutes } from '@shared/constants/allRoutes'
import LiveMatchCard from '@shared/components/liveMatchCard'

// const MyImage = dynamic(() => import('@shared/components/myImage'))

function EventMatchCard({ data, liveEventId }) {
  const [liveBlogData, setLiveBlogsData] = useState(data?.iMatchId ? data.oMatch : formatScoreData(data.oTeams))

  useSubscription(data?.iMatchId ? GET_MATCH_HEADER : GET_CUSTOM_SCORE_SUBSCRIPTION, {
    variables: { input: data?.iMatchId ? { iMatchId: data?.iMatchId } : { iEventId: liveEventId } },
    skip: typeof window === 'undefined',
    onSubscriptionData: ({ subscriptionData }) => {
      const md = subscriptionData?.data?.getMatchBySlug?.oMatchDetailsFront
      if (md) {
        setLiveBlogsData({
          ...liveBlogData,
          ...md,
          oTeamScoreA: { ...liveBlogData?.oTeamScoreA, ...md?.oTeamScoreA },
          oTeamScoreB: { ...liveBlogData?.oTeamScoreB, ...md?.oTeamScoreB }
        })
      } else if (subscriptionData?.data?.getLiveMatchScore?.oTeams) {
        setLiveBlogsData(formatScoreData(subscriptionData?.data?.getLiveMatchScore?.oTeams))
      }
    }
  })
  // const handleClick = (value) => {
  //   if (value?.sStatusStr === 'live') return allRoutes.matchDetailCommentary(value?.oSeo?.sSlug)
  //   else if (value?.sStatusStr === 'scheduled') return allRoutes.matchDetail(value?.oSeo?.sSlug)
  //   else if (value?.sStatusStr === 'completed' || value?.sStatusStr === 'cancelled') return allRoutes.matchDetailScorecard(`/${value?.oSeo?.sSlug}/`)
  // }

  return (
    <div style={{ border: '1px solid var(--border-light)', fontSize: '14px' }} className='br-lg font-medium small-text'>
      <LiveMatchCard data={liveBlogData} />
    </div>
  )
}

EventMatchCard.propTypes = {
  data: PropTypes.object,
  liveEventId: PropTypes.string
}

export default EventMatchCard
